jQuery(document).ready(function ($){

  function quickView() {
    jQuery(document).on('click','.quick-view', function () {
      if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
      var product_handle = $(this).data('handle');
      var product_id = $(this).data('id');
      var dots = $(this).data('dots');
      var slider_style = $(this).data('slider-style');
      var useDots = false;
      if (dots == true && slider_style == 'default') {useDots = true;}
      window.postMessage({ type: 'quickview', action: "open", product: product_id }, '*')
      var sub_only = $(this).data('subscriber-only');
      $('#quick-view').addClass(product_handle);
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        var title = product.title;
        var type = product.type;
        var price = 0;
        var original_price = 0;
        var desc = product.description;
        var images = product.images;
        var media = product.media;
        var variants = product.variants;
        var options = product.options;
        var url = '/products/' + product_handle;
        $('.qv-product-title').text(title);
        $('.qv-product-type').text(type);
        $('.qv-product-description').html(desc);
        $('.view-product').attr('href', url);

        //Subscription Product
        if (sub_only) {
          $(".subscriber-products-qv-container").removeClass("hidden");
          $(".qv-add-button, .qv-add-button + .view-product").addClass("hidden");
        } else {
          $(".subscriber-products-qv-container").addClass("hidden");
          $(".qv-add-button, .qv-add-button + .view-product").removeClass("hidden");
        }

        //Preorder
        var $pMessage = $('.preorder-message');
        var $pDate = $pMessage.children('strong');
        var pDate = false;

        for (var tag of product.tags) {
          if (tag.includes('preorder date')) {
            pDate = tag.replace('preorder date', '');
            break;
          }
        }
        if (pDate) {
          $pDate.text(pDate);
          $pMessage.show();
        } else {
          $pMessage.hide();
        }
        var buttonLabel = product.tags.includes('preorder')? 'Preorder' : 'Add to Cart';
        $('.qv-add-button').val(buttonLabel);

        //Gallery
        var imageCount = $(media).length;

        $(media).each(function (i, media) {
          if (i == imageCount - 1) {
            var image_embed = '<div><img alt="'+ title + '" data-index="' + i + '" data-media-id="' + media.id + '" src="' + media.src + '"></div>';
            image_embed = image_embed.replaceAll('.jpg', '_800x.jpg').replaceAll('.png', '_800x.png');
            $('.qv-product-images, .qv-product-slider-nav').append(image_embed);
            /* Original 
            $('.qv-product-images').slick({
              dots: false,
              arrows: true,
              respondTo: 'min',
              useTransform: false
            }).css('opacity', '1');
            */
            $('.qv-product-images').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              fade: true,
              dots: useDots,
              infinite:true,
              asNavFor: '.qv-product-slider-nav',
              instructionsText: 'Changing this current slide of this carousel will change the current slide of the thumbnail carousel that follows.',
              regionLabel: 'main image carousel',
              prevArrow: '.qv-prev',
              nextArrow: '.qv-next'
            }).css('opacity', '1');
            $('.qv-product-slider-nav').slick({
              slidesToShow: Math.min(3, imageCount),
              slidesToScroll: 1,
              asNavFor: '.qv-product-images',
              arrows: true,
              dots: false,
              centerMode: true,
              instructionsText: 'Changing the current slide of this carousel will change the current slide of the preceding main image carousel.',
              regionLabel: 'thumbnail carousel',
              focusOnSelect: true,
              prevArrow: '.qv-prev',
              nextArrow: '.qv-next'
            }).css('opacity', '1');
            window.addEventListener('message', function(m) {
              if (!m.type == 'variant_changed') return false;
              if (!m.data.variant) return false;
              var vMediaId = m.data.variant.featured_media.id;
              var index = document.querySelector('img[data-media-id="' + vMediaId + '"]').dataset.index;
              $('.qv-product-images').slick('slickGoTo', index);
            });
          } else {
            var image_embed = '<div><img alt="'+ title + '" data-index="' + i + '" data-media-id="' + media.id + '" src="' + media.src + '"></div>';
            image_embed = image_embed.replaceAll('.jpg', '_800x.jpg').replaceAll('.png', '_800x.png');
            $('.qv-product-images, .qv-product-slider-nav').append(image_embed);
          }
        });
        $(options).each(function (i, option) {
          var opt = option.name;
          var selectClass = '.option.' + opt.toLowerCase();
          var isSwatch = (opt == 'Color');
          $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container"><span class="option-name">' + opt + '<div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
          $(option.values).each(function (i, value) {
            var swatchUrl = '//snowdam.s3.us-east-2.amazonaws.com/swatch/' +
              value.toLowerCase().replaceAll('/', '-').replaceAll(' ', '-') + '.png';
            var labelInner = isSwatch? '<img alt="' + value + '" src="' +
              swatchUrl +
              '" onerror="this.onerror=null;this.src=\'//snowdam.s3.us-east-2.amazonaws.com/swatch/broken-image.jpg\';">' : value;
            var labelClass = isSwatch? ' class="qv-swatch"' : '';
            $(selectClass).append(
                '<input type="radio" id="' +
                opt.toLowerCase() + '-' + value.toLowerCase() +
                '" name="' + opt + '" value="' + value + '" aria-label=' + value + '"></input>' +
                '<label' + labelClass + ' for="' + opt.toLowerCase() + '-' + value.toLowerCase() + '">' +
                 labelInner + '</label>'
            );
          });
          $("input:radio[name='"+ opt + "']:first-of-type" ).prop('checked', true);
          $("input:radio[name='"+ opt + "']:first-of-type" ).attr('checked',true);
        });
        
        $(product.variants).each(function (i, v) {
          if (v.inventory_quantity == 0) {
            $('.qv-add-button').prop('disabled', true).val('Sold Out');
            $('.qv-add-to-cart').hide();
            $('.qv-product-price').text('Sold Out').show();
            return true
          } else {
            price = parseFloat(v.price / 100).toFixed(2);
            original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            $('.qv-product-price').text('$' + price);
            if (original_price > 0) {
              $('.qv-product-original-price').text('$' + original_price).show();
              //Discount Percentage
              let discountPercentage = Math.round((1 - (price / original_price)) * 100);
              $('.qv-product-discount').text('Save ' + discountPercentage + '%');
            } else {
              $('.qv-product-discount').hide();
              $('.qv-product-original-price').hide();
            }
            $('select.option-0').val(v.option1);
            $('select.option-1').val(v.option2);
            $('select.option-2').val(v.option3);
            return false
          }
        });
      });
      $(document).on("change", "#quick-view input", function () {
        var selectedOptions = '';
        $('#quick-view input:radio:checked').each(function (i) {
          $(this).parent().prev().find('.option-name-selection').text($(this).val());
          if (selectedOptions == '') {
            selectedOptions = $(this).val();
          } else {
            selectedOptions = selectedOptions + ' / ' + $(this).val();
          }
        });
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          $(product.variants).each(function (i, v) {
            if (v.title == selectedOptions) {
              var price = parseFloat(v.price / 100).toFixed(2);
              var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
              var v_qty = v.inventory_quantity;
              var v_inv = v.inventory_management;
              window.postMessage({ type: 'variant_changed', variant: v }, '*')
              $('.qv-product-price').text('$' + price);
              if (original_price > 0) {
              $('.qv-product-original-price').text('$' + original_price).show();
              //Discount Percentage
              let discountPercentage = Math.round((1 - (price / original_price)) * 100);
              $('.qv-product-discount').text('Save ' + discountPercentage + '%');
            } else {
              $('.qv-product-discount').hide();
              $('.qv-product-original-price').hide();
            }
              var buttonLabel = product.tags.includes('preorder')? 'Preorder' : 'Add to Cart';
              if (v_inv == null) {
                $('.qv-add-button').prop('disabled', false).val(buttonLabel);
              } else {
                if (v.available == false) {
                  $('.qv-add-button').prop('disabled', true).val('Sold Out');
                } else {
                  $('.qv-add-button').prop('disabled', false).val(buttonLabel);
                }
              }
            }
          });
        });
      });
      $(document).on("change", "#quick-view select", function () {
        var selectedOptions = '';
        $('#quick-view select').each(function (i) {
          if (selectedOptions == '') {
            selectedOptions = $(this).val();
          } else {
            selectedOptions = selectedOptions + ' / ' + $(this).val();
          }
        });
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          $(product.variants).each(function (i, v) {
            if (v.title == selectedOptions) {
              var price = parseFloat(v.price / 100).toFixed(2);
              var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
              window.postMessage({ type: 'variant_changed', variant: v }, '*')
              var v_qty = v.inventory_quantity;
              var v_inv = v.inventory_management;
              $('.qv-product-price').text('$' + price);
              if (original_price > 0) {
              $('.qv-product-original-price').text('$' + original_price).show();
              //Discount Percentage
              let discountPercentage = Math.round((1 - (price / original_price)) * 100);
              $('.qv-product-discount').text('Save ' + discountPercentage + '%');
            } else {
              $('.qv-product-discount').hide();
              $('.qv-product-original-price').hide();
            }
              var buttonLabel = product.tags.includes('preorder')? 'Preorder' : 'Add to Cart';
              if (v_inv == null) {
                $('.qv-add-button').prop('disabled', false).val(buttonLabel);
              } else {
                if (v.available == false) {
                  $('.qv-add-button').prop('disabled', true).val('Sold Out');
                } else {
                  $('.qv-add-button').prop('disabled', false).val(buttonLabel);
                }
              }
            }
          });
        });
      });
      $.fancybox({
        href: '#quick-view',
        maxWidth: 1040,
        maxHeight: 600,
        fitToView: true,
        width: '75%',
        height: '70%',
        autoSize: false,
        closeClick: false,
        openEffect: 'none',
        closeEffect: 'none',
        'beforeLoad': function () {
          /*var product_handle = $('#quick-view').attr('class');*/
          $(document).on("click", ".qv-add-button", function () {
            var qty = $('.qv-quantity').val();
            var selectedOptions = '';
            var var_id = '';
            $('#quick-view input:radio:checked').each(function (i) {
          
              if (selectedOptions == '') {
                selectedOptions = $(this).val();
              } else {
                selectedOptions = selectedOptions + ' / ' + $(this).val();
              }
            });
            $('#quick-view select').each(function (i) {
              if (selectedOptions == '') {
                selectedOptions = $(this).val();
              } else {
                selectedOptions = selectedOptions + ' / ' + $(this).val();
              }
            });
            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
              $(product.variants).each(function (i, v) {
                if (v.title == selectedOptions) {
                  var_id = v.id;
                  processCart();
                }
              });
            });
            function processCart() {
              jQuery.post('/cart/add.js', {
                  quantity: qty,
                  id: var_id,
                  sections: 'cart-icon-bubble,cart-drawer'
                },
                null,
                "json")
                .done(function (response) {
                  $('.qv-add-to-cart-response')
                    .addClass('success')
                    .removeClass('error')
                    .html('<span>' + $('.qv-product-title').text() + ' has been added to your <a href="/cart">CART</a>.');

                  document.getElementById('cart-icon-bubble').innerHTML = response.sections['cart-icon-bubble'];
                  document.getElementById('shopify-section-cart-drawer').outerHTML = response.sections['cart-drawer'];
                })
                .fail(function ($xhr) {
                  var data = $xhr.responseJSON;
                  console.log(data);
                  $('.qv-add-to-cart-response')
                    .addClass('error')
                    .removeClass('success')
                    .html('<span><b>ERROR: </b>' + data.description);
                }
            );
          }
          });
          $('.fancybox-wrap').css('overflow', 'hidden !important');
        },
        'afterShow': function () {
          $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
            $('.qv-product-images, .qv-product-slider-nav').addClass('loaded');
          });
        },
        'afterClose': function () {
          $('#quick-view').removeClass().empty();
          window.postMessage({ type: 'quickview', action: "close" }, '*');
        }
      });
    });
   };
   
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });

 });
  
 jQuery(window).resize(function ($){
  if (jQuery('#quick-view').is(':visible')) {
    jQuery('.qv-product-images, .qv-product-slider-nav').slick('setPosition');
  }
 });
